function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "#795556"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "url(#paint0_radial_28327_7648)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "url(#paint1_radial_28327_7648)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "url(#paint2_linear_28327_7648)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "url(#paint3_linear_28327_7648)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "url(#paint4_linear_28327_7648)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1806 29.9607H12.8689C12.3331 29.9607 11.9259 29.3523 12.0438 28.718L12.5581 25.9607H19.4914L20.0057 28.718C20.1129 29.3523 19.7164 29.9607 19.1806 29.9607Z",
  fill: "url(#paint5_linear_28327_7648)"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_28327_7648)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3777 19.2576H19.6689C21.7577 19.2576 22.6049 19.5605 23.703 20.7263C24.3827 21.5362 25.0467 22.4065 24.9686 24.0076C24.8749 25.9294 23.7656 26.8982 21.4687 26.8982H10.5779C8.28106 26.8982 7.17172 25.9294 7.07799 24.0076C6.99991 22.4065 7.66387 21.5362 8.3436 20.7263C9.44169 19.5605 10.2889 19.2576 12.3777 19.2576Z",
  fill: "url(#paint6_radial_28327_7648)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3777 19.2576H19.6689C21.7577 19.2576 22.6049 19.5605 23.703 20.7263C24.3827 21.5362 25.0467 22.4065 24.9686 24.0076C24.8749 25.9294 23.7656 26.8982 21.4687 26.8982H10.5779C8.28106 26.8982 7.17172 25.9294 7.07799 24.0076C6.99991 22.4065 7.66387 21.5362 8.3436 20.7263C9.44169 19.5605 10.2889 19.2576 12.3777 19.2576Z",
  fill: "url(#paint7_radial_28327_7648)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3777 19.2576H19.6689C21.7577 19.2576 22.6049 19.5605 23.703 20.7263C24.3827 21.5362 25.0467 22.4065 24.9686 24.0076C24.8749 25.9294 23.7656 26.8982 21.4687 26.8982H10.5779C8.28106 26.8982 7.17172 25.9294 7.07799 24.0076C6.99991 22.4065 7.66387 21.5362 8.3436 20.7263C9.44169 19.5605 10.2889 19.2576 12.3777 19.2576Z",
  fill: "url(#paint8_radial_28327_7648)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3777 19.2576H19.6689C21.7577 19.2576 22.6049 19.5605 23.703 20.7263C24.3827 21.5362 25.0467 22.4065 24.9686 24.0076C24.8749 25.9294 23.7656 26.8982 21.4687 26.8982H10.5779C8.28106 26.8982 7.17172 25.9294 7.07799 24.0076C6.99991 22.4065 7.66387 21.5362 8.3436 20.7263C9.44169 19.5605 10.2889 19.2576 12.3777 19.2576Z",
  fill: "url(#paint9_linear_28327_7648)"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3777 19.2576H19.6689C21.7577 19.2576 22.6049 19.5605 23.703 20.7263C24.3827 21.5362 25.0467 22.4065 24.9686 24.0076C24.8749 25.9294 23.7656 26.8982 21.4687 26.8982H10.5779C8.28106 26.8982 7.17172 25.9294 7.07799 24.0076C6.99991 22.4065 7.66387 21.5362 8.3436 20.7263C9.44169 19.5605 10.2889 19.2576 12.3777 19.2576Z",
  fill: "url(#paint10_radial_28327_7648)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint11_radial_28327_7648)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint12_linear_28327_7648)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint13_radial_28327_7648)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint14_radial_28327_7648)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint15_radial_28327_7648)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint16_radial_28327_7648)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6498 13.8044C12.6536 13.8044 11.8007 14.1521 11.0859 14.9841C11.0581 15.0205 11.03 15.0569 11.0018 15.0935C10.581 15.6393 10.1256 16.2301 9.96085 17.2774C9.89051 18.6091 10.5438 19.2576 11.6484 19.2576H20.3672C21.4717 19.2576 22.1251 18.6091 22.0547 17.2774C21.89 16.2301 21.4346 15.6393 21.0138 15.0935C20.9855 15.0569 20.9575 15.0205 20.9297 14.9841C20.2148 14.1521 19.362 13.8044 18.3658 13.8044H13.6498Z",
  fill: "url(#paint17_radial_28327_7648)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint18_linear_28327_7648)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint19_radial_28327_7648)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint20_radial_28327_7648)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint21_linear_28327_7648)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint22_radial_28327_7648)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint23_radial_28327_7648)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7084 7.16854C15.278 6.131 16.7686 6.13099 17.3382 7.16853L19.9242 11.879C20.3998 12.7454 19.7729 13.8046 18.7846 13.8046H13.2621C12.2737 13.8046 11.6469 12.7454 12.1225 11.879L14.7084 7.16854Z",
  fill: "url(#paint24_linear_28327_7648)"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_28327_7648)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.4239,
  cy: 23.078,
  rx: 5.59668,
  ry: 2.59411,
  fill: "url(#paint25_radial_28327_7648)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.4239,
  cy: 23.078,
  rx: 5.59668,
  ry: 2.59411,
  fill: "url(#paint26_radial_28327_7648)"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_28327_7648)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.7717,
  cy: 16.531,
  rx: 4.43646,
  ry: 1.58594,
  fill: "url(#paint27_radial_28327_7648)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.7717,
  cy: 16.531,
  rx: 4.43646,
  ry: 1.58594,
  fill: "url(#paint28_radial_28327_7648)"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_28327_7648)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.1093 12.2828C15.8005 11.9703 17.6228 11.5484 19.3827 12.3609C18.6254 12.6057 16.7104 12.9328 15.1093 12.2828Z",
  fill: "url(#paint29_linear_28327_7648)"
}));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_28327_7648)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5996 6.87134V12.5446H19.7522L16.5996 6.87134Z",
  fill: "url(#paint30_linear_28327_7648)"
}));

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_28327_7648",
  x: 7.07172,
  y: 19.2576,
  width: 18.1532,
  height: 7.64062,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.486275 0 0 0 0 0.6 0 0 0 0 0.513726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7648"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_28327_7648",
  x: 10.8273,
  y: 18.4839,
  width: 15.1934,
  height: 9.18823,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7648"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_28327_7648",
  x: 10.3352,
  y: 12.9451,
  width: 12.8729,
  height: 7.17188,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7648"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_28327_7648",
  x: 14.1093,
  y: 10.8906,
  width: 6.27344,
  height: 2.77295,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7648"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_28327_7648",
  x: 15.5996,
  y: 5.87134,
  width: 5.15253,
  height: 7.67334,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7648"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.251 25.9607) rotate(70.3276) scale(3.03988 1.95488)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34016,
  stopColor: "#5F2F2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F2F2E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.2453 25.516) rotate(102.416) scale(5.35131 2.99668)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.480716,
  stopColor: "#5F2F2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.967279,
  stopColor: "#5F2F2E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_28327_7648",
  x1: 16.0233,
  y1: 30.0759,
  x2: 15.8748,
  y2: 28.8584,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7B4064"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7B4064",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_28327_7648",
  x1: 11.5597,
  y1: 27.7976,
  x2: 12.9833,
  y2: 27.9607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#826C6A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#826C6A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_28327_7648",
  x1: 20.179,
  y1: 27.6026,
  x2: 19.282,
  y2: 27.9607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#826C6A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#826C6A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_28327_7648",
  x1: 16.0233,
  y1: 29.7223,
  x2: 16.0233,
  y2: 30.0239,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8F5790",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8F5790"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.2936 23.0779) rotate(180) scale(16.4585 9.1748)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#80C156"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#52915C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0233 18.0668) rotate(90) scale(5.01113 22.6983)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57A22C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#57A22C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.3174 26.8982) scale(10.0406 1.58933)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7F779B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F779B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_28327_7648",
  x1: 17.1141,
  y1: 27.1753,
  x2: 17.1141,
  y2: 26.4338,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7F779B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F779B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.5472 18.8976) rotate(173.698) scale(9.53308 2.17183)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#105B0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#105B0D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.5993 16.531) rotate(180) scale(11.1275 6.54807)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#80C156"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#52915C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_28327_7648",
  x1: 11.0935,
  y1: 16.531,
  x2: 17.0189,
  y2: 16.531,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#529257"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#529257",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0078 12.9546) rotate(90) scale(3.57645 15.3461)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57A22C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#57A22C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0078 19.6463) rotate(-90) scale(1.80124 9.00368)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#479820"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#479820",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0078 19.3982) rotate(-90) scale(0.84375 7.43741)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#15600B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15600B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.0599 19.4914) rotate(-164.816) scale(12.5421 6.6444)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.870799,
  stopColor: "#75947D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#75947D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint17_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.0702 13.2732) rotate(90) scale(1.07813 7.3989)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#15600B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15600B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_28327_7648",
  x1: 14.6483,
  y1: 11.0486,
  x2: 19.3983,
  y2: 11.0486,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A9D57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7FC43A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0233 14.1171) rotate(-90) scale(1.8125 8.0625)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3B9017"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B9017",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.5162 13.425) rotate(-11.411) scale(3.97154 4.72088)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#608371"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#608371",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_28327_7648",
  x1: 11.9602,
  y1: 10.0975,
  x2: 13.6062,
  y2: 10.7138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#608371"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#608371",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint22_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.401 14.2559) rotate(-47.7702) scale(1.29022 2.51187)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#637374"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#637374",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint23_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.6514 14.3147) rotate(-4.99539) scale(4.3886 0.993436)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#15600B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15600B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_28327_7648",
  x1: 16.0233,
  y1: 6.39038,
  x2: 16.0233,
  y2: 7.57377,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#639E52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70A960",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint25_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.489 23.078) rotate(-180) scale(9.74151 1.76903)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2E070"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2E070",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint26_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.7107 23.078) scale(13.1471 4.03716)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.882353,
  stopColor: "#9FDF6B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9FDF6B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint27_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.5794 16.531) rotate(-180) scale(7.72205 1.08151)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2E070"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2E070",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint28_radial_28327_7648",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.6574 16.531) scale(10.4217 2.46816)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.882353,
  stopColor: "#9FDF6B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9FDF6B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_28327_7648",
  x1: 18.6631,
  y1: 12.2771,
  x2: 15.326,
  y2: 12.2771,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9DD573"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9DD573",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear_28327_7648",
  x1: 18.553,
  y1: 9.84193,
  x2: 16.6104,
  y2: 10.3618,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AD869"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9AD869",
  stopOpacity: 0
})));

function SvgEvergreenTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvergreenTree);
export default __webpack_public_path__ + "static/media/evergreen-tree.60496dae.svg";
export { ForwardRef as ReactComponent };